require('../../sass/web/app.scss')
require('jquery') # all angular element will be wrapped by jquery
require('angular')
require('angular-route')
require('angular-cookies')
require('jquery-html5-placeholder-shim')
require('angular-placeholder-shim')
require('./components/analyze-access/analyze-access-module')
require('./components/browser/browser-module.coffee')
require('./session/session-module')
require('./paid-introduction/paid-introduction-module')
require('./password/password-module')
require('./setting/setting-module')
require('./registration/registration-module')
require('./score-registration/score-registration-module')
require('./term/term-module')
require('./analysis/analysis-module')
require('./analysis-event/analysis-module')
require('./history/index-module')
require('./dashboard/dashboard-module')
require('./goal-settings/goal-settings-module.coffee')
require('./round-detail/round-detail-module')
require('./history/index-module')
require('./dashboard/dashboard-module')
require('./goal-settings/goal-settings-module.coffee')
require('./friend/friend-module')
require('./contact/contact-module')
require('./components/title/title-module')
require('./policy/policy-module')
require('./legal/legal-module')
require('./email-confirmation/email-confirmation-module')
require('./club/club-module')
require('./groups/group-registration-module')
require('./components/truncate/truncate_module.coffee')
require('./profile/index-module')

modules = [
  'ngRoute'
  'ngCookies'
  'placeholderShim'
  'gnp-translation'
  'gnp-browser'
  'gnp-app-title'
  'gnp-analyze-access'
  'gnp-app-session'
  'gnp-app-paid-introduction'
  'gnp-app-password'
  'gnp-app-setting'
  'gnp-app-registration'
  'gnp-app-term'
  'gnp-app-history'
  'gnp-app-score-registration'
  'gnp-app-dashboard'
  'gnp-app-analysis'
  'gnp-app-analysis-event'
  'gnp-app-goal-settings'
  'gnp-app-round-detail'
  'gnp-app-friend'
  'gnp-app-contact'
  'gnp-app-policy'
  'gnp-app-legal'
  'gnp-app-email-confirmation'
  'gnp-app-club'
  'gnp-app-group'
  'gnp-app-profile'
  'gnp-truncate'
]

angular.module 'gnp-app', modules
  .config ['$routeProvider',  ($routeProvider) ->
    $routeProvider
      .otherwise
        redirectTo: '/'
  ]
  .config ['$httpProvider', ($httpProvider) ->
    $httpProvider.defaults.headers.common['X-CSRF-Token'] =
      $('meta[name=csrf-token]').attr('content')
  ]
  .config ['$locationProvider', ($locationProvider) ->
    $locationProvider.html5Mode(true)
  ]
  .config ['$cookiesProvider', ($cookiesProvider) ->
    $cookiesProvider.defaults.secure = true
  ]



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/app.coffee